import { CountUp } from "countup.js";

const componentCounterStart = () => {
	const countYear = document.querySelector("#year");

	if (countYear) {
        const countOptions = {
            separator: "",
            duration: 4,
            startVal: 1908,
        };

        let counterGridData = countYear.dataset.number;
    
        const countUp = new CountUp(countYear, counterGridData, countOptions);
        countUp.start();
	}
};

export default componentCounterStart;
